// Minimal i18n: all user-facing copy lives in locale JSON (spec section 6).
// Components never hard-code text. Add de/fr/es/it by dropping JSON files
// with the same shape and extending `locales`.

import en from "../locales/en.json";

type Locale = typeof en;
const locales: Record<string, Locale> = { en };

let current = "en";

export function setLanguage(lang: string): void {
  if (locales[lang]) current = lang;
}

/** Resolve a dot path like "home.title" from the active locale. */
export function t(path: string): string {
  const parts = path.split(".");
  let node: unknown = locales[current];
  for (const p of parts) {
    if (typeof node !== "object" || node === null) return path;
    node = (node as Record<string, unknown>)[p];
  }
  return typeof node === "string" ? node : path;
}

/**
 * Resolve a non-string node (arrays / objects). Never throws: a missing
 * path returns the provided fallback so a content mistake can never blank
 * the whole page.
 */
export function tNode<T>(path: string, fallback: T): T {
  const parts = path.split(".");
  let node: unknown = locales[current];
  for (const p of parts) {
    if (typeof node !== "object" || node === null) return fallback;
    node = (node as Record<string, unknown>)[p];
  }
  return node === undefined || node === null ? fallback : (node as T);
}
